export class PaymentRequestModel {
  cardDetails: CardDetails;
  reference: string;
  amount: number;
  customerId: string;
  currency: string;
}

export class AuthRequestModel {
  cardDetails: CardDetails;
  paymentId: string;
  otp: string;
}

export class AuthResponseModel {
  paymentId: string;
  transactionRef: string;
  providerReference: string;
  amount: string;
  responseCode: string;
  responseDescription: string;
}

export class CardDetails {
  authDataVersion: number;
  pan: string;
  expiryDate: string;
  cvv2: string;
  pin: string;
}

export class ResponseModel {
  paymentId: string;
  amount: number;
  transactionReference: string;
  plainTextSupportMessage: string;
  acsUrl: string;
  termUrl: string;
  jwt: string;
  responseCode: string;
  responseDescription: string;
}
